import { Modal, TextBase, TextSubHeader } from '@carboncopyco/ui';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';
import { WorkspaceManageTagControls } from './WorkspaceManageTagControls';
import { WorkspaceManageTagCreate } from './WorkspaceManageTagCreate';
import { WorkspaceManageTagEmpty } from './WorkspaceManageTagEmpty';
import { WorkspaceManageTagList } from './WorkspaceManageTagList';
import { WorkspaceManageTagSearch } from './WorkspaceManageTagSearch';

export const WorkspaceManageTagModalBody = () => {
  const { isLoading, onClose, isOpen, workspaceName, tags } =
    useWorkspaceManageTag();
  return (
    <Modal
      open={isOpen}
      title={
        <div className="flex items-center w-[460px]">
          <TextSubHeader
            ellipsis
            label={`Manage tags for ${workspaceName}`}
            color="text-ds-natural-600"
          />
        </div>
      }
      onClose={onClose}
    >
      <div className="flex flex-col gap-3 w-[460px] mt-3 h-[496px]">
        <TextBase
          label="Assign tags to organize workspaces using keywords, simplifying search and access."
          color="text-ds-natural-600"
        />
        <div className="w-full mt-2.5 justify-between justify-items-stretch">
          {tags.length === 0 && !isLoading ? (
            <>
              <WorkspaceManageTagEmpty />
              <WorkspaceManageTagControls />
            </>
          ) : (
            <div className="h-[434px] flex flex-col justify-between">
              <div>
                {tags.length > 0 ? <WorkspaceManageTagSearch /> : null}
                <WorkspaceManageTagList />
                <WorkspaceManageTagCreate />
              </div>
              <WorkspaceManageTagControls />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
